import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { CompanyDeletionPayload } from './company-deletion.types';

// deprecated service ref.: deleteCompanyService_DEPRECATED

// ✅ Implementado
export async function deleteCompanyService({ query: rawQuery }: CompanyDeletionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.delete(ENDPOINT.COMPANIES, { query });

  return {
    response,
    summary: data,
  };
}
